(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    const tabContainers = document.querySelectorAll('.product-tabs');
    tabContainers.forEach(function (container) {
      const tabs = container.querySelectorAll('.product-tabs__tab');
      const panels = container.querySelectorAll('.product-tabs__panel');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          // Deactivate all tabs
          tabs.forEach(function (t) {
            t.classList.remove('product-tabs__tab--active');
            t.setAttribute('aria-selected', 'false');
          });

          // Hide all panels
          panels.forEach(function (p) {
            p.hidden = true;
          });

          // Activate clicked tab
          tab.classList.add('product-tabs__tab--active');
          tab.setAttribute('aria-selected', 'true');

          // Show corresponding panel
          var panelId = tab.getAttribute('aria-controls');
          var panel = container.querySelector('#' + panelId);
          if (panel) {
            panel.hidden = false;
          }
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-cart-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-cart-bar')) {
    class StickyCartBar extends HTMLElement {
      connectedCallback() {
        this.formId = this.dataset.formId;
        this.mainForm = document.getElementById(this.formId);
        this.mainSection = this.mainForm ? this.mainForm.closest('.section-main-product') : null;
        this.variantSelect = this.querySelector('[data-sticky-variant]');
        this.addBtn = this.querySelector('[data-sticky-add]');
        this.addLabel = this.querySelector('[data-sticky-add-label]');
        this.priceEl = this.querySelector('[data-sticky-price]');

        if (!this.mainForm) return;

        this.setupObserver();
        this.wireVariantSelect();
        this.wireAddBtn();
        this.listenForChanges();
      }

      setupObserver() {
        const trigger = this.mainSection && this.mainSection.querySelector('product-form');
        if (!trigger) return;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.hide();
              } else {
                this.show();
              }
            });
          },
          { threshold: 0, rootMargin: '0px 0px -40px 0px' }
        );
        this.observer.observe(trigger);
      }

      show() {
        this.dataset.visible = 'true';
        this.removeAttribute('inert');
        this.setAttribute('aria-hidden', 'false');
      }

      hide() {
        delete this.dataset.visible;
        this.setAttribute('inert', '');
        this.setAttribute('aria-hidden', 'true');
      }

      wireVariantSelect() {
        if (!this.variantSelect) return;
        this.variantSelect.addEventListener('change', () => {
          const variantId = this.variantSelect.value;
          // Find the matching variant in the main form and click its radio
          const targetRadio = this.mainForm.querySelector('input[type="radio"][data-variant-id="' + variantId + '"]');
          if (targetRadio) {
            targetRadio.checked = true;
            targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          // Fallback: look up the variant data via variant-selects element
          const vs = this.mainSection && this.mainSection.querySelector('variant-selects');
          if (vs && vs.variantData) {
            const variant = vs.variantData.find((v) => String(v.id) === String(variantId));
            if (!variant) return;
            variant.options.forEach((value, i) => {
              const group = vs.querySelectorAll('[data-option-position]')[i];
              if (!group) return;
              if (group.tagName === 'SELECT') {
                group.value = value;
                group.dispatchEvent(new Event('change', { bubbles: true }));
              } else {
                const radio = group.querySelector('input[value="' + CSS.escape(value) + '"]');
                if (radio) {
                  radio.checked = true;
                  radio.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            });
          }
        });
      }

      wireAddBtn() {
        if (!this.addBtn || !this.mainForm) return;
        this.addBtn.addEventListener('click', () => {
          if (this.addBtn.disabled) return;
          // Delegate to the main form so <product-form> handles everything
          if (typeof this.mainForm.requestSubmit === 'function') {
            this.mainForm.requestSubmit();
          } else {
            this.mainForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          }
        });
      }

      listenForChanges() {
        document.addEventListener('dahabeya:variant:change', (e) => {
          const v = e.detail && e.detail.variant;
          if (!v) {
            this.addBtn.disabled = true;
            return;
          }
          if (this.variantSelect) this.variantSelect.value = v.id;
          if (this.priceEl) {
            const n = v.price / 100;
            this.priceEl.textContent = Number.isInteger(n) ? String(n) : n.toFixed(2);
          }
          this.addBtn.disabled = !v.available;
        });
        document.addEventListener('dahabeya:cart:add', () => {
          if (!this.addBtn || !this.addLabel) return;
          const original = this.addLabel.textContent;
          this.addBtn.dataset.success = 'true';
          this.addLabel.textContent = (document.documentElement.lang === 'ar')
            ? 'انضاف للسلة'
            : 'Added';
          window.setTimeout(() => {
            delete this.addBtn.dataset.success;
            this.addLabel.textContent = original;
          }, 1600);
        });
      }
    }
    customElements.define('sticky-cart-bar', StickyCartBar);
  }
  } catch(e) { console.error(e); }
})();

})();
